import I18N from '@leverege/i18n'
import { HistoryView } from '@leverege/molten/data-viewers'

import defaultAnalyticsModel from './defaultAnalyticsModel'

const id = 'ps.dataViewers.AnalyticsDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.Analytics',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : 'GroupDataViewer', objectType : 'station' },
  createSettings : ( props ) => {
    return defaultAnalyticsModel
  },

  component : HistoryView,
  getDefaultCardContentOptions : { height : '400px', needsDate : true, needsCondition : true, needsOrder : true }
}
